import "./style.css";
import { faPrint, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Input } from "../Input";
import { convertDateToBr, dateNow, getHourMin } from "../../utils/dateProvider";
import { LoadAdm } from "../LoadAdm";
import { fetchAllPedidos } from "../../utils/fetchAllPedidosGeral";
import { gerarPDF } from "../../utils/gerarPdfPedidosGeral";
import { IClientesCtrl } from "../../pages/ControleHome";

type IProps = {
  closeModal: () => void;
  clientes: IClientesCtrl[]
};

export function ModalRelatorioDciGeral({ closeModal, clientes }: IProps) {
  const [dataIni, setDataIni] = useState(convertDateToBr(dateNow()));
  const [dataFin, setDataFin] = useState(convertDateToBr(dateNow()));

  const [clienteSelected, setClientesSelected] = useState<string>("0");

  const [loading, setLoading] = useState(false);

  function formatarData(dataStr: string) {
    const [dia, mes, ano] = dataStr.split('/');
    return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
  }

  const handleImprimir = async () => {
    setLoading(true);

    try {
      const dataIniUS = formatarData(dataIni);
      const dataFinUS = formatarData(dataFin);

      const getData = await fetchAllPedidos(dataIniUS, dataFinUS, clienteSelected !== "0" ? parseInt(clienteSelected) : undefined );

      await gerarPDF(getData);
      
    } catch (err) {
      console.log(err);
      alert("Erro ao gerar relatório. Tente novamente mais tarde.");
    }
    finally{
      setLoading(false);
    }
  };

  return (
    <div id="mdControleRelDciGeral">
      <div className="header">
        <h3>Relatório Pedidos DCI Geral</h3>
        <FontAwesomeIcon
          icon={faTimes}
          style={{ cursor: "pointer" }}
          onClick={closeModal}
        />
      </div>

      {loading && (
        <LoadAdm
          txtLoading="Gerando Relatório..."
          options={{ height: 150, width: 150 }}
        />
      )}

      <div className="content">
        {!loading && (
          <>
            <div>
              <select 
                value={clienteSelected}
                onChange={(e) => { setClientesSelected(e.currentTarget.value) }}
              >
                <option value={0}>Todos</option>
                {clientes.map((item) => {
                  return <option value={item.id}>{item.nome}</option>
                })}
              </select>
            </div>
            <div>
              <span>
                <p style={{ fontWeight: "600" }}>Data Inicial:</p>
                <Input
                  mask="date"
                  value={dataIni}
                  inputMaskChange={setDataIni}
                  placeholder="dd/mm/aaaa"
                  maxLength={10}
                />
              </span>
              <span>
                <p style={{ fontWeight: "600" }}>Data Final:</p>
                <Input
                  mask="date"
                  value={dataFin}
                  inputMaskChange={setDataFin}
                  placeholder="dd/mm/aaaa"
                  maxLength={10}
                />
              </span>
            </div>

            <button type="button" onClick={() => handleImprimir()}>
              <FontAwesomeIcon icon={faPrint} />
              IMPRIMIR
            </button>
          </>
        )}
      </div>
    </div>
  );
}
